import { makeStyles } from '@material-ui/core/styles';
import { LayoutDirection } from 'features/app/ts/LayoutDirection';

export const useStyles = makeStyles(theme => ({
  selectFieldLabel: {
    display: 'flex',
    fontSize: theme.spacing(7),
    fontWeight: 400,
    lineHeight: '18px',
    color: '#000000',
    paddingBottom: theme.spacing(3),

    [theme.breakpoints.down('sm')]: {
      fontSize: theme.spacing(4.5),
      lineHeight: '11px',
    },
  },
  selectedSelectField: {
    '& .MuiInputBase-input': {
      backgroundColor: '#fff !important',
    },
  },
  baseSignUpForm: {
    '& label': {
      marginTop: theme.spacing(12.5),
    },
  },
  firstNameInputField: {
    // paddingRight: theme.spacing(4),
    padding: ({ direction }: LayoutDirection) => direction === 'rtl' ? `0 0 0 ${theme.spacing(4)}px` : `0 ${theme.spacing(4)}px 0 0`,
    width: '50%',
  },
  lastNameInputField: {
    // paddingLeft: theme.spacing(4),
    padding: ({ direction }: LayoutDirection) => direction === 'rtl' ? `0 0 0 ${theme.spacing(4)}px` : `0 ${theme.spacing(4)}px 0 0`,
    width: '50%',
  },
  selectField: {
    position: 'relative',

    '& .Mui-focused > .MuiInputBase-input': {
      boxShadow: '0px 5px 10px #E0E4EE',
      backgroundColor: '#fff ',
    },
    '& .MuiInputBase-input': {
      border: 'unset !important',
      boxShadow: 'unset',
      color: '#2D2D2D',
      borderRadius: theme.spacing(2.5),
      transition: theme.transitions.create(['background-color', 'box-shadow']),
      padding: theme.spacing(7, 10.5, 7, 6.5),
    },
    '& p': {
      lineHeight: '18px',
    },

    [theme.breakpoints.down('sm')]: {
      '& .MuiInputBase-input': {
        fontSize: theme.spacing(6),
        padding: theme.spacing(2.5, 9),
      },
      '& p': {
        fontSize: theme.spacing(6),
      },
    },
  },
  selectHelperText: {
    position: 'absolute',
    bottom: theme.spacing(-10),
  },
  linkToLoginContainer: {
    marginTop: theme.spacing(7),
    fontSize: theme.spacing(7),
    color: '#233B58',
    letterSpacing: 0,

    '& a': {
      color: '#474DDC',
      textDecoration: 'none',
    },

    [theme.breakpoints.down('sm')]: { fontSize: theme.spacing(4.5), lineHeight: '11px', textAlign: 'center' },
  },
  nextBtn: {
    marginTop: theme.spacing(14.5),

    '& span': {
      textTransform: 'capitalize',
      font: 'normal normal bold 16px/18px Roboto',
      '& > i': {
        display: 'inline-block',
      },
    },

    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(6),
      marginTop: theme.spacing(12.5),

      '& span': {
        fontSize: theme.spacing(7),
      },
    },
  },
  linkLabel: {
    '& > span': {
      display: 'flex',
    },
  },
}));
